import { motion } from "framer-motion";
import { MapPin, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COURSE_LOCATION_NAME, COURSE_LOCATION_AREA, MAPS_EMBED_URL, MAPS_SEARCH_URL } from "./kursusConstants";

export function LocationSection() {
  return (
    <section id="lokasi" data-testid="kursus-location" className="bg-kursus-bg2 py-20 sm:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-4xl text-kursus-white mb-3"
        >
          LOKASI <span className="text-kursus-gold">LATIHAN</span>
        </motion.h2>
        <div className="flex items-center justify-center gap-2 text-kursus-white mb-8">
          <MapPin className="w-4 h-4 text-kursus-gold" />
          <p className="font-oswald text-base sm:text-lg tracking-wide">{COURSE_LOCATION_NAME}, {COURSE_LOCATION_AREA}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="rounded-lg overflow-hidden border border-kursus-border mb-6 bg-kursus-card"
          data-testid="kursus-map-panel"
        >
          <iframe
            title="Lokasi Kem Metang Gana"
            src={MAPS_EMBED_URL}
            className="kursus-map-dark w-full h-64 sm:h-80 border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>

        <a href={MAPS_SEARCH_URL} target="_blank" rel="noreferrer" data-testid="kursus-open-location-btn">
          <Button className="bg-kursus-gold hover:bg-kursus-goldbright text-black font-oswald font-bold tracking-wide gap-2">
            BUKA LOKASI <ExternalLink className="w-4 h-4" />
          </Button>
        </a>
      </div>
    </section>
  );
}
